import { ValueType } from 'realgrid'

export const ordRegFields = [
    { fieldName: 'itemSeq', dataType: ValueType.NUMBER },
    { fieldName: 'ordNo', dataType: ValueType.TEXT },
    { fieldName: 'ordQty', dataType: ValueType.NUMBER },
    { fieldName: 'itemCd', dataType: ValueType.TEXT },
    { fieldName: 'ua1', dataType: ValueType.TEXT },
    { fieldName: 'ua2', dataType: ValueType.TEXT },
    { fieldName: 'itemNm', dataType: ValueType.TEXT },
    { fieldName: 'nickNm', dataType: ValueType.TEXT },
    { fieldName: 'avaQty', dataType: ValueType.NUMBER },
    { fieldName: 'avaYn', dataType: ValueType.TEXT },
    { fieldName: 'remark', dataType: ValueType.TEXT },
    { fieldName: 'itemSub', dataType: ValueType.TEXT}
]

export const ordRegColumns = [
    {
        name: 'itemSeq',
        fieldName: 'itemSeq',
        type: 'data',
        width: '50',
        styleName: "rg-align-center",
        header: {
            text: '제품순번',
            showTooltip: false
        },
        visible: false,
        editable: false
    },
    {
        name: 'ordQty',
        fieldName: 'ordQty',
        type: 'data',
        width: '80',
        numberFormat: "#,##0.#",
        styleName: "rg-align-right",
        header: {
            text: '주문수량',
            showTooltip: false
        },
        editable: true,
        footer: {
            text: "합계",
            expression: "sum",
        }
    },
    {
        name: 'ordNo',
        fieldName: 'ordNo',
        type: 'data',
        width: '80',
        styleName: "rg-align-left",
        header: '원주문번호',
        visible: false,
        editable: false
    },
    {
        name: 'itemCd',
        fieldName: 'itemCd',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: '제품코드',
        editable: false
    },
    {
        name: 'ua1',
        fieldName: 'ua1',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: 'Cylinder',
        visible: true,
        editable: false
    },
    {
        name: 'ua2',
        fieldName: 'ua2',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: 'Diopter',
        visible: true,
        editable: false
    },
    {
        name: 'itemNm',
        fieldName: 'itemNm',
        type: 'data',
        width: '200',
        styleName: "rg-align-left",
        header: '제품명',
        editable: false
    },
    {
        name: 'nickNm',
        fieldName: 'nickNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: '별칭',
        visible: true,
        editable: false
    },
    {
        name: 'avaQty',
        fieldName: 'avaQty',
        type: 'data',
        width: '50',
        numberFormat: "#,##0.#",
        styleName: "rg-align-right",
        header: {
            text: '주문가능수량',
            showTooltip: false
        },
        visible: false,
        editable: false
    },
    {
        name: 'avaYn',
        fieldName: 'avaYn',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: '재고보유여부',
        editable: false
    },
    {
        name: 'remark',
        fieldName: 'remark',
        type: 'data',
        width: '120',
        styleName: "rg-align-right",
        header: {
            text: '수술예정일 or 비고',
            showTooltip: false
        },
        editable: true,
    },
    {
        name: 'itemSub',
        fieldName: 'itemSub',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: {
          text: '삭제',
        },
        renderer:{
          type:"button",
          "hideWhenEmpty": true
        },
        editable: false,
      }
]